import { playerService } from './player-service';
import { roundService } from './round-service';
import { courseService } from './course-service';
import { Round, RoundStatus } from '../models/round';
import { Course, Hole } from '../models/course';


class ServiceFacade {

    public async createRound(roundName: string, playerName: string, courseId?: string) {

        try {
            // TODO: error handling
            // create player
            const playerResponse = await playerService.createPlayer(playerName);

            // create round
            const roundResponse = await roundService.createRound(roundName, playerResponse.body.id, courseId);

            // attach player to round.
            const attachResponse = await roundService.attachPlayerToRound(roundResponse.body.id, playerResponse.body.id);


            return {
                body: {
                    round: roundResponse.body,
                    player: {
                        id: playerResponse.body.id,
                        name: playerResponse.body.name,
                    },
                },
                status: roundResponse.status,
            };
        } catch (error) {
            console.error('Error creating round:', error);
            throw error;
        }

    }

    public async getRound(roundId: string, playerId: string) {
        try {
            const response = await roundService.getRound(roundId);

            const round: Round = response.body;
            const player = round.players.find(p => p.id === playerId);
            round.player = player;

            return round;
        } catch (error) {
            console.error('Error getting round:', error);
            throw error;
        }
    }

    public async updateScore(roundId: string, playerId: string, hole: number, score: number) {
        try {
            await roundService.recordScore(roundId, playerId, hole, score);
            return await this.getRound(roundId, playerId);
        } catch (error) {
            console.error('Error updating score:', error);
            throw error;
        }
    }

    public async completeRound(roundId: string, playerId: string) {
        try {
            await roundService.updatePlayerRoundStatus(roundId, playerId, RoundStatus.COMPLETED);
            return await this.getRound(roundId, playerId);
        } catch (error) {
            console.error('Error completing round:', error);
            throw error;
        }
    }

    public async editRound(roundId: string, playerId: string) {
        try {
            await roundService.updatePlayerRoundStatus(roundId, playerId, RoundStatus.IN_PROGRESS);
            return await this.getRound(roundId, playerId);
        } catch (error) {
            console.error('Error completing round:', error);
            throw error;
        }
    }

    public async getSharedRound(roundId: string) {
        try {
            const response = await roundService.getRound(roundId);
            return response.body;
        } catch (error) {
            console.error('Error getting shared round:', error);
            throw error;
        }
    }

    public async joinRound(roundId: string, playerName: string) {
        try {
            const playerResponse = await playerService.createPlayer(playerName);
            await roundService.attachPlayerToRound(roundId, playerResponse.body.id);
            return {
                body: {
                    player: {
                        id: playerResponse.body.id,
                        name: playerResponse.body.name,
                    },
                },
            };
        } catch (error) {
            console.error('Error joining round:', error);
            throw error;
        }
    }

    public async listCourses() {
        const response = await courseService.listCourses();
        return response.body.courses;
    }

    public async getCourse(id: string): Promise<Course> {
        const response = await courseService.getCourse(id);
        return response.body;
    }

    public async createCourse(name: string, holes: Hole[]): Promise<Course> {
        const response = await courseService.createCourse(name, holes);
        return response.body;
    }

    public async updateCourse(id: string, updates: { name?: string; holes?: Hole[] }): Promise<Course> {
        const response = await courseService.updateCourse(id, updates);
        return response.body;
    }

    public async setHolePar(roundId: string, playerId: string, hole: number, par: number): Promise<Round> {
        try {
            await roundService.setHolePar(roundId, playerId, hole, par);
            return await this.getRound(roundId, playerId);
        } catch (error) {
            console.error('Error setting hole par:', error);
            throw error;
        }
    }
}

export const serviceFacade = new ServiceFacade();